package com.example.readingnotes.domain.usecase

import com.example.readingnotes.domain.model.AuthState
import com.example.readingnotes.domain.repository.AuthRepository
import com.example.readingnotes.util.Result

class RegisterUserUseCase(
    private val authRepository: AuthRepository,
) {
    suspend operator fun invoke(username: String, password: String): Result<AuthState> {
        if (username.isBlank()) {
            return Result.failure(IllegalArgumentException("ユーザー名を入力してください"))
        }
        if (!username.matches(Regex("^[a-zA-Z0-9]{6,20}$"))) {
            return Result.failure(IllegalArgumentException("ユーザー名は6-20文字の半角英数字で入力してください"))
        }
        if (password.length < 8) {
            return Result.failure(IllegalArgumentException("パスワードは8文字以上で入力してください"))
        }
        return authRepository.register(username, password)
    }
}
